class NotifyMeSlideout extends HHBaseElement {
  constructor() {
    super()

    this.productForm = this.querySelector('#slideout-notify-me-form')
    this.emailInput = this.querySelector('#slideout-notify-me-email')
    this.skuInput = this.querySelector('#slideout-notify-me-sku')
    this.productIdInput = this.querySelector('#slideout-notify-me-product-id')
    this.newsletterInput = this.querySelector('#slideout-notify-me-nesletter')
    this.atcButton = this.querySelector('.js-slideout-notify-me-atc')
    this.sendNotifyMeRequest = this.sendNotifyMeRequest.bind(this)
  }

  connectedCallback() {
    this.productForm.addEventListener('submit', this.sendNotifyMeRequest.bind(this))
  }

  disconnectedCallback() {
    this.productForm.removeEventListener('submit', this.sendNotifyMeRequest)
  }

  async sendNotifyMeRequest(e) {
    e.preventDefault()
    const triggerButton = this.atcButton

    try {
      if (triggerButton) {
        triggerButton.setAttribute('loading', true)
      }
      let subscribedValue = null
      if (this.newsletterInput.checked) {
        subscribedValue = 'subscribed'
      }

      const auth_data = { email: this.emailInput.value }
      const contact_data = {
        channels: { email: { subscribeStatus: subscribedValue } },
        opt_in_source: 'back_in_stock_modal',
        ...(subscribedValue
          ? {
              channels: { email: { subscribeStatus: subscribedValue } },
            }
          : {}),
      }
      await crdl('contact', auth_data, contact_data)

      const properties = {
        sku: this.skuInput.value,
        productID: this.productIdInput.value
      }
      await crdl('event', 'back_in_stock_signup', properties)
    } finally {
      if (triggerButton) {
        triggerButton.removeAttribute('loading')
      }

      this.closest('slide-panel')
        ._shadowRoot.querySelector('.slide-panel__backdrop')
        .click()
    }
  }
}

window.customElements.define('notify-me-slideout', NotifyMeSlideout)
